// FASE 05: espelho de MaterialEnum.Tipo do legado (api/MOF.DataServices/Enums/MaterialEnum.cs).
// Atencao: KIT = 6 aqui, diferente do backend novo (que usa 9) — este modulo fala com o legado.
export enum MaterialEnum {
  PERFIL = 1,
  COMPONENTE = 2,
  VIDRO = 3,
  SUPERFICIE = 4,
  ACABAMENTO = 5,
  KIT = 6,
}
